// extracted by css-extract-rspack-plugin
export default {"bodyMinHeight":"_b538845f"};